import React, { useEffect, useState } from 'react';
import { AdvertisingProvider } from '@this/ads-prebid';
import { withBreakpoint } from '@trulia/txl';

import {
  getFormattedAdTargetings,
  getAdUnitPrefix,
  isTimeForNewAd,
  isUpdatedKeyVals,
} from './searchResultsAdsUtils';

const SearchResultsPrebidAdsProvider = (props) => {
  const { children, ...restProps } = props;
  const [ stateProps, setStateProps ] = useState(restProps);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!restProps.adTargetings || !stateProps.adTargetings || !restProps.filters) {
      return;
    }

    if (stateProps.isAdvertisingRestricted !== restProps.isAdvertisingRestricted
      || stateProps.tabIndex !== restProps.tabIndex
    ) {
      setStateProps(restProps);
      return;
    }

    if (isTimeForNewAd(restProps.filters, stateProps.filters)
      || isUpdatedKeyVals(restProps.adTargetings.keyVals, stateProps.adTargetings.keyVals)
    ) {
      setStateProps(restProps);
    }
  });

  if (typeof window === 'undefined' || !stateProps.adTargetings) {
    return children;
  }

  const { adTargetings, breakpoint, isAdvertisingRestricted, isPrebidEnabled, tabIndex } = stateProps;
  const formattedAdTargetings = getFormattedAdTargetings(adTargetings, tabIndex, true);
  const adUnitPath = getAdUnitPrefix(formattedAdTargetings['listtp'], tabIndex, isAdvertisingRestricted, breakpoint);

  let adSlotId = 'search_1';
  if (isAdvertisingRestricted) {
    adSlotId += '_restricted';
  }

  let adSlotsDetails = [
    {
      id: adSlotId,
      path: `/${adUnitPath}`,
      sizes: ['fluid'],
    }
  ];

  if (isPrebidEnabled) {
    return <AdvertisingProvider
      {...stateProps}
      config={{
        path: `/${adUnitPath}`,
        prebid: {
          bidderTimeout: 2000,
        },
        usePrebid: true,
        targeting: formattedAdTargetings,
        enableLazyLoad: false,
        slots: adSlotsDetails,
        metaData: {},
      }}
      children={children}
    />;
  }

  return children;
};

export default withBreakpoint(SearchResultsPrebidAdsProvider);
